import { EDruhVynosu } from 'enums/isin/udaje/druhVynosu';

const druhVynosuSelect = [
    {
        value: EDruhVynosu.P,
        labelcz: 'ISIN_EMISE_AKCIE_VYNOS_P'
    },
    {
        value: EDruhVynosu.KP,
        labelcz: 'ISIN_EMISE_AKCIE_VYNOS_KUMULATIVNI_P'
    },
    {
        value: EDruhVynosu.PC,
        labelcz: 'ISIN_EMISE_AKCIE_VYNOS_PC'
    },
    {
        value: EDruhVynosu.KPC,
        labelcz: 'ISIN_EMISE_AKCIE_VYNOS_KUMULATIVNI_PC'
    },
    {
        value: EDruhVynosu.PR,
        labelcz: 'ISIN_EMISE_AKCIE_VYNOS_PR'
    },
    {
        value: EDruhVynosu.N,
        labelcz: 'ISIN_EMISE_AKCIE_VYNOS_N'
    },
    {
        value: EDruhVynosu.A,
        labelcz: 'ISIN_EMISE_AKCIE_VYNOS_A'
    }
];

export default druhVynosuSelect;
